import { render } from "./JournalAbbr.vue?vue&type=template&id=7add77b4&scoped=true"
import script from "./JournalAbbr.vue?vue&type=script&lang=js"
export * from "./JournalAbbr.vue?vue&type=script&lang=js"

import "./JournalAbbr.vue?vue&type=style&index=0&id=7add77b4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7add77b4"]])

export default __exports__